export const UI_TRANSLATIONS: Record<string, Record<string, string>> = {
  'Turkish': {
    'welcome': 'Hoş Geldiniz!',
    'choose_language': 'Çeviriler ve destek için ana dilinizi seçin.',
    'start_journey': 'Yolculuğa Başla',
    'next_step': 'Sonraki Adım',
    'back': 'Geri',
    'grammar_academy': 'Dilbilgisi Akademisi',
    'master_english': 'A1\'den C2\'ye İngilizceyi Uzmanlaşın!',
    'support_language': 'Destek Dili',
    'play_scramble': 'Karıştırma Oyunu Oyna',
    'beginner': 'Başlangıç',
    'elementary': 'Temel',
    'intermediate': 'Orta',
    'upper_intermediate': 'Orta Üstü',
    'advanced': 'İleri',
    'proficiency': 'Yetkinlik',
    'lessons_coming_soon': 'Bu seviye için daha fazla ders yakında gelecek!',
    'start_lesson': 'Derse Başla',
    'start_practice': 'Pratiğe Başla',
    'check_answer': 'Cevabı Kontrol Et',
    'correct': 'Doğru!',
    'wrong': 'Yanlış!',
    'excellent': 'Mükemmel!',
    'lesson_complete': 'Ders Tamamlandı!',
    'xp_earned': 'XP Kazandınız!',
    'ai_adventures': 'Yapay Zeka Maceraları',
    'embark_quests': 'Destansı görevlere atılın. İngilizceniz silahınızdır!',
    'inventory': 'ENVANTER',
    'tutor_tip': 'ÖĞRETMEN İPUCU',
    'try_again': 'TEKRAR DENE',
    'word_rush': 'KELİME AKINI',
    'match_words': 'Kelimeleri anlamlarıyla eşleştirin. Kombolar için ÇİFT XP kazanın!',
    'choose_battleground': 'Savaş Alanınızı Seçin',
    'start_rush': 'AKINI BAŞLAT',
    'fever_mode': 'ATEŞ MODU AKTİF',
    'unstoppable': 'DURDURULAMAZ!',
    'loot_earned': 'Kazanılan Ganimet',
    'max_combo': 'Maksimum Kombo',
    'fever_state': 'Ateş Durumu',
    'replay_arcade': 'TEKRAR OYNA',
  },
  'Spanish': {
    'welcome': '¡Bienvenido!',
    'choose_language': 'Elige tu idioma nativo para traducciones y apoyo.',
    'start_journey': 'Comenzar Viaje',
    'next_step': 'Siguiente Paso',
    'back': 'Atrás',
    'grammar_academy': 'Academia de Gramática',
    'master_english': '¡Domina el inglés de A1 a C2!',
    'support_language': 'Idioma de Apoyo',
    'play_scramble': 'Jugar Juego de Mezcla',
    'beginner': 'Principiante',
    'elementary': 'Elemental',
    'intermediate': 'Intermedio',
    'upper_intermediate': 'Intermedio Superior',
    'advanced': 'Avanzado',
    'proficiency': 'Competencia',
    'lessons_coming_soon': '¡Más lecciones próximamente para este nivel!',
    'start_lesson': 'Comenzar Lección',
    'start_practice': 'Comenzar Práctica',
    'check_answer': 'Verificar Respuesta',
    'correct': '¡Correcto!',
    'wrong': '¡Incorrecto!',
    'excellent': '¡Excelente!',
    'lesson_complete': '¡Lección Completada!',
    'xp_earned': '¡XP Ganada!',
    'ai_adventures': 'Aventuras de IA',
    'embark_quests': 'Embárcate en misiones épicas. ¡Tu inglés es tu arma!',
    'inventory': 'INVENTARIO',
    'tutor_tip': 'CONSEJO DEL TUTOR',
    'try_again': 'INTENTAR DE NUEVO',
    'word_rush': 'RUSH DE PALABRAS',
    'match_words': 'Empareja palabras con significados. ¡Gana DOBLE XP por combos!',
    'choose_battleground': 'Elige tu Campo de Batalla',
    'start_rush': 'INICIAR RUSH',
    'fever_mode': 'MODO FIEBRE ACTIVO',
    'unstoppable': '¡IMPARABLE!',
    'loot_earned': 'Botín Ganado',
    'max_combo': 'Combo Máximo',
    'fever_state': 'Estado de Fiebre',
    'replay_arcade': 'REPETIR ARCADE',
  },
  // Add more languages as needed...
};

export const SCENARIO_TRANSLATIONS: Record<string, Record<string, { title: string; description: string }>> = {
  'Turkish': {
    'quest-kids-1': { title: 'Kayıp Kedi', description: 'Komşunuzun kedisini bulmasına yardım edin. İpuçlarını takip edin!' },
    'quest-kids-2': { title: 'Uzay Marketi', description: 'Bir uzaylıya marketten ne alacağını söyleyin. Dikkatli olun!' },
    'quest-adult-1': { title: 'İş Görüşmesi', description: 'Hayalinizdeki işi kapın. Profesyonel olun!' },
    'quest-adult-2': { title: 'Otel Şikayeti', description: 'Odanızdaki sorunu çözün. Nazik ama kararlı olun!' },
    'quest-travel-1': { title: 'Havalimanı Giriş', description: 'Gümrükten geçin ve uçuşunuzu kaçırmadan giriş yapın!' },
    'quest-travel-2': { title: 'Tokyo\'da Kaybolmak', description: 'Yerellere otelinizi sorun. Kaybolmayın!' },
    'quest-business-2': { title: 'Maaş Pazarlığı', description: 'Yeni sözleşmenizi müzakere edin. Kararlı ama kibar olun!' },
    'quest-academic-1': { title: 'Tez Savunması', description: 'Profesörün sorularına karşı araştırma kağıdınızı savunun.' },
  },
  'Spanish': {
    'quest-kids-1': { title: 'El Gato Perdido', description: 'Ayuda a tu vecino a encontrar su gato. ¡Sigue las pistas!' },
    'quest-kids-2': { title: 'Supermercado Espacial', description: 'Dile a un alienígena qué comprar. ¡Ten cuidado!' },
    'quest-adult-1': { title: 'Entrevista de Trabajo', description: 'Consigue el trabajo de tus sueños. ¡Sé profesional!' },
    'quest-adult-2': { title: 'Queja en el Hotel', description: 'Resuelve el problema en tu habitación. ¡Sé amable pero firme!' },
    'quest-travel-1': { title: 'Check-in en el Aeropuerto', description: '¡Pasa por la aduana y haz el check-in sin perder tu vuelo!' },
    'quest-travel-2': { title: 'Perdido en Tokio', description: 'Pregunta a los lugareños por tu hotel. ¡No te pierdas!' },
    'quest-business-2': { title: 'Negociación Salarial', description: 'Negocia tu nuevo contrato. ¡Sé firme pero educado!' },
    'quest-academic-1': { title: 'Defensa de Tesis', description: 'Defiende tu trabajo de investigación ante las preguntas del profesor.' },
  },
};
